
// @ts-nocheck


export const localeCodes =  [
  "de",
  "en",
  "fr",
  "nl"
]

export const localeLoaders = {
  "de": [{ key: "../lang/de/de", load: () => import("../lang/de/de" /* webpackChunkName: "locale__home_forge_app_inaia_finance_lang_de_de" */), cache: true }],
  "en": [{ key: "../lang/en/en", load: () => import("../lang/en/en" /* webpackChunkName: "locale__home_forge_app_inaia_finance_lang_en_en" */), cache: true }],
  "fr": [{ key: "../lang/fr/fr", load: () => import("../lang/fr/fr" /* webpackChunkName: "locale__home_forge_app_inaia_finance_lang_fr_fr" */), cache: true }],
  "nl": [{ key: "../lang/nl/gggnl", load: () => import("../lang/nl/gggnl" /* webpackChunkName: "locale__home_forge_app_inaia_finance_lang_nl_gggnl" */), cache: true }]
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "__i18n_config_ts_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "./i18n.config.ts",
  "locales": [
    {
      "name": "Deutsch",
      "code": "de",
      "iso": "de-DE",
      "img": "/assets/img/flags/germany-48.png",
      "files": [
        "lang/de/de"
      ]
    },
    {
      "name": "English",
      "code": "en",
      "iso": "en-GB",
      "img": "/assets/img/flags/great-britain-48.png",
      "files": [
        "lang/en/en"
      ]
    },
    {
      "name": "Français",
      "code": "fr",
      "iso": "fr-FR",
      "img": "assets/img/flags/france-48.png",
      "files": [
        "lang/fr/fr"
      ]
    },
    {
      "name": "Nederlands",
      "code": "nl",
      "iso": "nl-NL",
      "img": "assets/img/flags/netherlands-48.png",
      "files": [
        "lang/nl/gggnl"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix",
  "lazy": true,
  "langDir": "lang/",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "name": "Deutsch",
    "code": "de",
    "iso": "de-DE",
    "img": "/assets/img/flags/germany-48.png",
    "files": [
      {
        "path": "lang/de/de"
      }
    ]
  },
  {
    "name": "English",
    "code": "en",
    "iso": "en-GB",
    "img": "/assets/img/flags/great-britain-48.png",
    "files": [
      {
        "path": "lang/en/en"
      }
    ]
  },
  {
    "name": "Français",
    "code": "fr",
    "iso": "fr-FR",
    "img": "assets/img/flags/france-48.png",
    "files": [
      {
        "path": "lang/fr/fr"
      }
    ]
  },
  {
    "name": "Nederlands",
    "code": "nl",
    "iso": "nl-NL",
    "img": "assets/img/flags/netherlands-48.png",
    "files": [
      {
        "path": "lang/nl/gggnl"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
